import actionTypes from '../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.billingPage.set,
  data,
});

export const getSummaryAction = (data) => ({
  type: actionTypes.billingPage.getSummary,
  data,
});
